import {
	Container,
	Typography,
	Box,
	TextField,
	Button,
	Select,
	MenuItem,
	InputLabel,
	FormControl,
} from "@mui/material";
import { styled, StyledEngineProvider } from "@mui/material/styles";
import logo from "../../assets/img/logos/logo-grupo-monaco.jpg";
import { Link } from "react-router-dom";
import { Fragment } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import "./AccountCreationForm.css";

const LoginTextField = styled(TextField)({
	input: {
		color: "#292929",
		"&:-webkit-autofill": {
			WebkitBoxShadow: "0 0 0 1000px #fdfeff inset",
			WebkitTextFillColor: "#292929 !important",
		},
	},
	InputLabelProps: {
		color: "#292929",
		fontFamily: "Quicksand",
	},
	"&:-webkit-autofill": {
		WebkitBoxShadow: "0 0 0 1000px white inset",
	},
	"& label.Mui-focused": {
		color: "#292929",
	},
	"& .MuiOutlinedInput-root": {
		"& fieldset": {
			borderColor: "#292929",
		},
		"&:hover fieldset": {
			borderColor: "#292929",
		},
		"&.Mui-focused fieldset": {
			borderColor: "#e60b13",
		},
	},
});

const LoginSelect = styled(Select)({
	color: "#292929",
	"& fieldset": {
		borderColor: "#292929",
	},
	"&.MuiOutlinedInput-root.Mui-focused": {
		"& fieldset": {
			borderColor: "#e60b13",
		},
	},
});

function AccountCreationForm({ handleSubmit, handleChange, dataForm }) {
	const docTypes = [
		{ idDoc: 1, docType: "C.U.I.T." },
		{ idDoc: 2, docType: "C.U.I.L." },
		{ idDoc: 3, docType: "L.E." },
		{ idDoc: 4, docType: "Pasaporte" },
		{ idDoc: 5, docType: "DNI" },
		{ idDoc: 6, docType: "Código AFIP" },
	];

	return (
		<StyledEngineProvider injectFirst>
			<Link to="/login">
				<Box
					float="left"
					display="flex"
					margin="1rem 0 0 1rem"
					alignItems="center"
				>
					<ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
					<Typography variant="subtitle2" color="initial" ml={1}>
						Volver a Inicio de Sesión
					</Typography>
				</Box>
			</Link>
			<Container
				maxWidth="xs"
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContect: "space-between",
					alignItems: "center",
					height: "100%",
					color: "#292929",
					paddingTop: 3,
					paddingBottom: 3,
				}}
			>
				<Link to="/">
					<img
						src={logo}
						alt="Logo de El Don Mayorista"
						className="form-logo"
					/>
				</Link>
				<FormControl
					component="form"
					onSubmit={handleSubmit}
					sx={{
						mt: 2,
						// textAlign: "center"
					}}
				>
					<Typography
						component="h1"
						sx={{ fontFamily: "Quicksand", textAlign: "center" }}
					>
						CREAR CUENTA
					</Typography>

					{dataForm.map((field, index) => {
						if (field.element === "input") {
							return (
								<Fragment key={field.id}>
									<LoginTextField
										id={field.id}
										name={field.id}
										type={field.type}
										label={field.label}
										onChange={handleChange}
										variant="outlined"
										margin="normal"
										fullWidth
										value={dataForm[index].value}
									/>

									<Typography variant="body1" color="error">
										{dataForm[index].error}
									</Typography>
								</Fragment>
							);
						} else {
							return (
								<FormControl sx={{ mt: 2, mb: 1 }} key={field.id}>
									<InputLabel
										className="inputLabel"
										id="docTypeSelect"
										sx={{
											"&.MuiFormLabel-root.MuiInputLabel-root.Mui-focused": {
												color: "#292929",
											},
										}}
									>
										Tipo Documento
									</InputLabel>
									<LoginSelect
										labelId="docTypeSelect"
										name={field.id}
										value={field.value || ""}
										label="Tipo de documento"
										onChange={handleChange}
									>
										{docTypes?.map((docType) => {
											return (
												<MenuItem
													key={docType.idDoc}
													name={docType.docType}
													value={docType.idDoc}
													sx={{ textTransform: "capitalize" }}
												>
													{docType.docType}
												</MenuItem>
											);
										})}
									</LoginSelect>
									<Typography variant="body1" color="error">
										{dataForm[index].error}
									</Typography>
								</FormControl>
							);
						}
					})}
					<Button
						id="btnForm"
						type="submit"
						color="brand"
						fullWidth
						variant="contained"
						sx={{
							mt: 2,
							fontSize: "1rem",
							fontWeight: 700,
							textTransform: "none",
						}}
						style={{ fontFamily: "Quicksand" }}
					>
						Solicitar cuenta
					</Button>
					<Typography
						component="h6"
						sx={{ fontFamily: "Quicksand", textAlign: "center" }}
					>
						Una vez solicitada su cuenta, el equipo de Ventas se pondrá en
						contacto para validar su registro.
					</Typography>
				</FormControl>
			</Container>
		</StyledEngineProvider>
	);
}

export default AccountCreationForm;
